import React from 'react';
import OInput from '../../../UI/FormControls/OInput';
import OAutocomplete from '../../../UI/MuiAutocomplete';
import { useTranslation } from 'react-i18next';

const Inputs = ({ formValues, setFormValues, kategorijeData }) => {
  const { t, i18n } = useTranslation();
  const handleChange = (item) => {
    if (typeof formValues[item.target.name] === 'boolean') {
      setFormValues((curr) => {
        return { ...curr, [item.target.name]: item.target.checked };
      });
    } else {
      setFormValues((curr) => {
        return { ...curr, [item.target.name]: item.target.value };
      });
    }
  };
  const handleClickKategorije = (item) => {
    setFormValues((curr) => {
      return {
        ...curr,
        tip: item.id,
        nazivTipa: item.vrednost,
      };
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '2px',
        marginBottom: '10px',
      }}
    >
      <OInput
        label={t('name')}
        name="naziv"
        value={formValues.naziv}
        handleChange={handleChange}
        touched={formValues.touchedNaziv}
        setTouched={() => {
          setFormValues((curr) => {
            return { ...curr, touchedNaziv: true };
          });
        }}
        errorMessage="Naziv je obavezno polje"
        // style={{ width: '100%' }}
      />
      <OInput
        label={t('unitOfMeasure')}
        name="jm"
        value={formValues.jm}
        handleChange={handleChange}
        touched={formValues.touchedJM}
        setTouched={() => {
          setFormValues((curr) => {
            return { ...curr, touchedJM: true };
          });
        }}
        errorMessage="Jedinica mere je obavezno polje"
        // style={{ width: '100%' }}
      />
      <OInput
        type="number"
        label={t('priceTechnician')}
        name="cenaTehnicar"
        value={formValues.cenaTehnicar}
        handleChange={handleChange}
      />
      <OInput
        type="number"
        label={t('priceEngineer')}
        name="cenaInzenjer"
        value={formValues.cenaInzenjer}
        handleChange={handleChange}
      />
      <OInput
        type="number"
        label={t('priceTechnicianIno')}
        name="cenaTehnicarIno"
        value={formValues.cenaTehnicarIno}
        handleChange={handleChange}
      />
      <OInput
        type="number"
        label={t('priceEngineerIno')}
        name="cenaInzenjerIno"
        value={formValues.cenaInzenjerIno}
        handleChange={handleChange}
      />
      <OAutocomplete
        data={kategorijeData}
        value={formValues.nazivTipa}
        handleClick={handleClickKategorije}
        label={t('category')}
        style={{ width: '200px' }}
      />
    </div>
  );
};

export default Inputs;
